"use client"

import GetAppButtons from "@/components/GetAppButtons"
import { BodyDefault, BodySmall, Heading2, Heading4 } from "@/components/text"
import Image from "next/image"
import Link from "next/link"
import { SetStateAction, useEffect, useState } from "react"

const contentSlider = [
  {
    image: "/goodshift/img/home/carousel-1.jpg",
    title: "Vind goede doelen die bij jou passen",
    body: "Ontdek meer dan 200 goede doelen, bekijk thema’s of de bundels die we voor je hebben samengesteld. Er is altijd een goed doel dat bij jou past en dat jouw bijdrage kan gebruiken.",
  },
  {
    image: "/goodshift/img/home/carousel-2.jpg",
    title: "Start, pauzeer of stop je donaties wanneer je wilt",
    body: "Jij bent in controle en bepaalt waaraan, wanneer en hoeveel je doneert. Jij doneert op jouw manier: flexibel, makkelijk en overzichtelijk.",
  },
  {
    image: "/goodshift/img/home/carousel-3.jpg",
    title: "Zie de impact die we samen maken",
    body: "Met Good News blijf je op de hoogte van de mooie en belangrijke impact die de goede doelen maken, mede dankzij jouw bijdrage.",
  },
]

export default function ImageTextSections() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % contentSlider.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [])

  const handleClick = (i: SetStateAction<number>) => {
    setIndex(i)
  }

  return (
    <>
      <div className="relative overflow-hidden bg-white lg:overflow-visible pb-[4rem] md:pb-[7rem]">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-center contentSlider-center">
          <div className="lg:col-span-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1">
            <div className="lg:max-w-2lg float-left md:mr-[3rem]">
              <BodySmall className="text-red mb-[0.75rem] md:mb-[1rem]">Goodshift Giftcard</BodySmall>
              <Heading2>Doneer met je giftcard</Heading2>
              <BodyDefault className="my-[1.5rem]">
                Heb je een giftcard gekregen? Via de app kun je jouw giftcard gebruiken om te doneren aan het goede doel
                dat jij wil steunen.
              </BodyDefault>
              <ul className="text-[1rem] md:text-[1.125rem] font-bold leading-1.5 my-[1.25rem] md:my-[1.5rem]">
                <li>
                  <span className="font-normal">Stap 1:</span> Kies de bundel of het goede doel dat bij jou past.
                </li>
                <li>
                  <span className="font-normal">Stap 2:</span> Klik op &apos;Doneren&apos; en kies &apos;Gebruik je
                  giftcard&apos;.
                </li>
                <li>
                  <span className="font-normal">Stap 3:</span> Controleer en bevestig je donatie.{" "}
                </li>
                <li>
                  <span className="font-normal">Stap 4:</span> Volg de impact bij good news.
                </li>
              </ul>
              <BodyDefault>Samen maken we het verschil, één donatie tegelijk.</BodyDefault>

              <GetAppButtons justifyContent="left" />

              <span className="block w-1/1 text-left pt-[1.5rem] md:pl-[0.5rem] underline font-bold font-[1rem]">
                <Link href="/giftcard">Giftcards aanvragen</Link>
              </span>
            </div>
          </div>
          <div className="lg:col-start-2 md:ml-[2.5rem]">
            <Image
              width={620}
              height={620}
              alt="wisecards"
              src="/goodshift/img/home/giftcard.jpg"
              className="max-w-full rounded-xl object-cover"
            />
          </div>
        </div>
      </div>
      <div className="relative isolate overflow-hidden bg-white lg:overflow-visible lg:px-0 pt-[rem] md:pt-[7rem]">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-center contentSlider-center">
          <div
            className="hidden lg:col-span-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1 md:pr-[2.5rem] relative"
            style={{ width: "620px", height: "620px" }}>
            {contentSlider.map((item, i) => (
              <Image
                key={i}
                width={620}
                height={620}
                alt="appintro"
                src={item.image}
                className={`absolute top-0 left-0 w-full h-full rounded-xl object-cover transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0"}`}
              />
            ))}
          </div>
          <div className="lg:col-start-2 ml-[1.5rem]">
            <div className="lg:pl-4">
              <div className="lg:max-w-2lg float-right">
                {contentSlider.map((item, i) => (
                  <div
                    key={i}
                    onClick={() => handleClick(i)}
                    className={`my-[2.5rem] transition-all duration-1000 cursor-pointer border-l-2 pl-[2rem] ${i === index ? "border-red" : "border-transparent"}`}>
                    <Heading4>{item.title}</Heading4>
                    <BodySmall>{item.body}</BodySmall>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="md:hidden md:h-0 lg:col-start-2 md:ml-[2.5rem]">
          {contentSlider.map((item, i) => (
            <Image
              key={i}
              width={620}
              height={620}
              alt="wisecards"
              src={item.image}
              className={`max-w-full rounded-xl object-cover transition-opacity duration-1000 ${i === index ? "opacity-100" : "opacity-0 h-0"}`}
            />
          ))}
        </div>
      </div>
    </>
  )
}
